import {
  createCVDraft,
  generateCVDOCXFromDraft,
  generateCVPDFFromDraft,
  getCVDraftById,
  previewCVPDFFromDraft,
  previewCVDraftPayload,
  updateCVDraft,
  validateCVDraftForExport,
} from "@/lib/recruitmentApi";

const toCompletionScore = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const fetchDraftById = async (id) => {
  return getCVDraftById(id);
};

export const persistDraft = async ({ draftId, draft, expectedRevision = null }) => {
  if (draftId) {
    const updated = await updateCVDraft(draftId, draft, expectedRevision);
    return {
      draftId,
      status: updated?.status || "draft",
      completionScore: toCompletionScore(updated?.completion_score),
      contentRevision: Number(updated?.content_revision) || null,
      draft: updated?.draft || null,
    };
  }

  const created = await createCVDraft(draft);
  return {
    draftId: created?._id,
    status: created?.status || "draft",
    completionScore: toCompletionScore(created?.completion_score),
    contentRevision: Number(created?.content_revision) || null,
    draft: created?.draft || null,
  };
};

export const requestPreviewPdf = async (draftId) => {
  return previewCVPDFFromDraft(draftId);
};

export const requestPreviewPdfPayload = async (draft) => {
  return previewCVDraftPayload(draft);
};

export const requestGeneratePdf = async (draftId) => {
  return generateCVPDFFromDraft(draftId);
};

export const requestGenerateDocx = async (draftId) => {
  return generateCVDOCXFromDraft(draftId);
};

export const requestUserValidation = async (draftId) => {
  return validateCVDraftForExport(draftId);
};
